module.exports = __webpack_public_path__ + "assets/images/22-2eFJSSG.jpg";